<div class="h-16 md:h-16"></div>
<div class="bg-[#eeeff0] footer-radius font-sans text-gray-900 overflow-hidden flex flex-col">
    <div class="flex flex-1 overflow-hidden max-w-[1920px] mx-auto w-full">
        <aside class="w-[30%] border-r border-gray-200 bg-light-thm flex flex-col shrink-0 relative w-full md:w-[30%]"
                    [ngClass]="{ 'hidden md:flex': isMobile && showDetailView }">
            <div class="flex flex-col relative overflow-y-auto ">
                <div class=" sticky top-0 left-0 z-[22] w-full p-4 border-b border-gray-100 flex items-center gap-2 px-6 bg-white">
                    <i class="fa-solid fa-wand-magic-sparkles text-[#8B5CF6]"></i>
                    <p class="text-sm font-bold text-black">Curated Properties for You </p>
                </div>
                <div class="px-1 pt-1 border-b border-gray-100 bg-white">
                    <div class="flex gap-5 text-[14px] font-semibold pl-6 border-b border-gray-100">
                        <button
                            *ngFor="let tab of getTabData"
                            (click)="onTabChange(tab.id)"
                            [ngClass]="{
                                'text-purple-600 border-b-3': activeTab === tab.id,
                                ' hover:text-gray-600 transition': activeTab !== tab.id
                            }"
                            class="flex items-center gap-1 py-3"
                        >
                        {{ tab.label }}
                        @if(tab.count > 0 ){
                            <span  [ngClass]="{
                                'bg-black text-white': activeTab === tab.id,
                                'bg-gray-100 text-gray-500': activeTab !== tab.id
                            }" class="px-1.5 py-0.5 rounded-full text-[10px]">
                                {{ tab.count }}
                            </span>
                        } 
                        </button>
                    </div>
                </div> 
                <!-- New  -->
                 <div class="flex-1 overflow-y-auto px-6 py-4 space-y-3 bg-white">
                    <div
                        *ngFor="let property of filteredProperties; let i = index"
                        (click)="handlePropertyClick(property)"
                        [attr.data-selected]="property._id === selectedItem()?._id"
                        class="group relative rounded-2xl overflow-hidden cursor-pointer border
                                transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
                                hover:-translate-y-[2px]
                                shadow-[0_8px_30px_rgba(0,0,0,0.08)]
                                hover:shadow-[0_12px_40px_rgba(0,0,0,0.12)]"
                        [ngClass]="{
                            'border border-[#8B5CF6] shadow-[0_0_0_1px_rgba(127,119,221,0.15),0_10px_30px_rgba(127,119,221,0.12)] bg-gradient-to-br from-[#8C52FF15] to-transparent': property._id === selectedItem()?._id,
                            'bg-white border-[#EFEFEF] hover:border-gray-300': property._id !== selectedItem()?._id
                        }"
                        >

                        <!-- HERO -->
                        <div class="relative h-[160px] overflow-hidden bg-[#1c1c1c]">

                            <img
                            [src]="property.galleryImage && property.galleryImage[0] ? property.galleryImage[0] : 'assets/img/proFeature.png'"
                            (error)="$any($event.target).src = 'assets/img/proFeature.png'"
                            class="w-full h-full object-cover opacity-90 transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                            />

                            <div class="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>

                            <!-- BADGES (same logic preserved) -->
                            <div class="absolute top-2 left-2 flex flex-wrap gap-1">

                            <span
                                class="text-[10px] px-2.5 py-[4px] rounded-full 
                                    bg-black/50 text-white border border-white/40 backdrop-blur-sm">
                                {{ property.type }}
                            </span>

                            <span
                                class="text-[10px] px-2.5 py-[4px] rounded-full 
                                    bg-black/50 text-white/80 border border-white/40">
                                {{ property.possession + ' - ' + property.possessionYear || 'Under construction' }}
                            </span>

                            </div>

                            <!-- FAV -->
                            <button
                            (click)="toggleFav($event, property._id)"
                            [disabled]="togglingFavId === property._id"
                            class="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full
                                    bg-black/50 border border-white/30 backdrop-blur-sm
                                    transition-all duration-200 hover:scale-110 active:scale-95
                                    disabled:opacity-50 disabled:cursor-not-allowed"
                            [ngClass]="isFav(property._id) ? 'text-red-400 shadow-[0_0_10px_rgba(255,80,80,0.4)]' : 'text-white/80'"
                            >
                            <!-- Spinner -->
                            <svg *ngIf="togglingFavId === property._id"
                                class="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                            </svg>

                            <svg *ngIf="togglingFavId !== property._id && isFav(property._id)"
                                class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"/>
                            </svg>

                            <svg *ngIf="togglingFavId !== property._id && !isFav(property._id)"
                                class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-width="2"
                                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                            </svg>
                            </button>

                            <!-- PRICE + BHK -->
                            <div class="absolute bottom-2 left-3 right-3 flex justify-between items-end">

                            <span *ngIf="getPriceRange(property.price) as range"
                                class="text-[24px] font-semibold text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">
                                {{ range.min | inrShort }}
                                <ng-container *ngIf="!range.isSame">
                                - {{ range.max | inrShort }}
                                </ng-container>
                            </span>

                            <!-- SAME LOGIC (your old bhk loop preserved) -->
                            <div class="flex gap-1 flex-wrap justify-end">
                                <span
                                *ngFor="let item of property.price"
                                class="text-[10px] px-2 py-[3px] rounded-full 
                                        bg-black/50 text-white border border-white/20">
                                {{ item.bhkType }}
                                </span>
                            </div>

                            </div>

                        </div>

                        <!-- BODY -->
                        <div class="px-4 pt-3 pb-4">

                            <h3 class="text-[17px] font-semibold mb-1 tracking-tight"
                            [ngClass]="{
                                'text-[#534AB7]': property._id === selectedItem()?._id,
                                'text-[#111]': property._id !== selectedItem()?._id
                            }">
                            {{ property.name | titlecase }}
                            </h3>

                            <p class="flex items-center gap-1 text-[12px] text-gray-500">
                                <svg class="w-[10px] h-[10px] shrink-0 opacity-80" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                                </svg>
                                {{ formatAddressSide(property) }}
                            </p>

                            <!-- STATS -->
                            <div class="flex gap-3 mt-3">

                            <div class="flex-1 px-3 py-2 rounded-xl bg-white/80 backdrop-blur-md border border-gray-200/60">
                                <div class="text-[10px] flex gap-2 items-center text-gray-400 mb-1">
                                    <svg class="w-3 h-3 text-gray-500 shrink-0" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
                                    </svg>
                                    <span>Area</span>
                                </div>
                                <p class="text-[15px] font-medium text-gray-800">
                                {{ property?.superBuiltUpArea | numberFormat }} sqft.
                                </p>
                            </div>

                            <div class="flex-1 px-3 py-2 rounded-xl bg-white/80 backdrop-blur-md border border-gray-200/60">
                                <div class="text-[10px] flex gap-2 items-center text-gray-400 mb-1">
                                    <svg class="w-3 h-3 text-gray-500 shrink-0" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                                    </svg>
                                    <span>Type</span>
                                </div>
                                <p class="text-[15px] font-medium text-gray-800">
                                {{ property?.propertyType || 'Apartment' }}
                                </p>
                            </div>

                            </div>

                        </div>

                        </div>
                 </div>
            </div>
        </aside>

        <main class="flex-1 overflow-y-auto bg-white" *ngIf="selectedItem()" [ngClass]="{ 'hidden md:block': isMobile && !showDetailView }">
            <div class="p-4 max-w-6xl mx-auto">
                <div *ngIf="isMobile" class="sticky top-0 z-6 bg-white border-b border-gray-200 p-4 mb-4 flex items-center justify-between">
                    <button 
                        *ngIf="isMobile"
                        (click)="showDetailView = false"
                        class="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition">
                        <i class="fas fa-arrow-left"></i>
                        <span class="text-sm font-semibold">Back</span>
                    </button>
                    <h2 class="text-lg font-bold text-gray-900">Property Details</h2>
                    <div class="w-8"></div>
                </div>
                
                <div class="shadow-sm p-4 rounded-2xl box-shadow-ff">

                    <!-- Gallery -->
                    <app-gallery class="mb-8" [images]="selectedItem()?.galleryImage"></app-gallery>

                    <!-- Header -->
                    <div class="flex flex-col sm:flex-row justify-between items-start my-8">
                        
                        <div class="flex flex-col sm:max-w-[80%]">

                        <!-- Title -->
                        <h1 class="text-3xl font-semibold text-gray-900 mb-2">
                            {{ selectedItem().name | titlecase }}
                        </h1>

                        <div class="flex flex-col gap-1">

                            <!-- Price + Location -->
                            <div class="flex flex-col sm:flex-row sm:items-center mb-4 gap-3">
                            
                            <span class="text-xl font-medium text-gray-800" *ngIf="getPriceRange() as range">
                                {{ range.min | inrShort }}
                                <ng-container *ngIf="!range.isSame">
                                <span class="text-gray-400 mx-1">-</span>
                                {{ range.max | inrShort }}
                                </ng-container>
                            </span>

                            <span class="hidden sm:flex">|</span>

                            <p class="font-medium text-gray-500">
                                {{ selectedItem()?.microMarket?.micromarketName }}
                            </p>
                            </div>

                            <!-- Tags -->
                            <div class="flex flex-wrap gap-2 items-center">

                            <!-- BHK -->
                            <span *ngFor="let item of selectedItem().price"
                                class="text-[10px] font-bold text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded border border-indigo-100">
                                {{ item.bhkType }}
                            </span>

                            <!-- Possession -->
                            <span class="inline-flex items-center rounded-sm bg-[#EFEFEF] px-2 py-1 text-xs text-black gap-2">
                                <i class="fa fa-wrench text-gray-500"></i>
                                {{ selectedItem()?.possession }} - {{ selectedItem()?.possessionYear }}
                            </span>

                            </div>
                        </div>
                        </div>

                        <!-- CTA -->
                        <div class="flex sm:flex-col items-center justify-between sm:justify-center gap-3
                                sm:justify-end sm:gap-4
                                fixed sm:relative bottom-0 left-0 right-0
                                sm:bottom-auto sm:left-auto sm:right-auto
                                bg-white/60 backdrop-blur-md sm:bg-transparent
                                px-4 py-3 sm:p-0
                                border-t sm:border-0 border-gray-200
                                z-50">

                        <!-- LEFT (Mobile: date) -->
                        <span class="flex flex-col text-[11px] text-black sm:hidden">
                            Last updated: 
                            <span class="text-[14px]">{{ selectedItem().updatedAt | date:'dd MMM yyyy' }}</span>
                        </span>

                        <!-- RIGHT ACTIONS -->
                        <div class="flex items-center gap-3 sm:gap-4 ml-auto">

                            <!-- FAV -->
                            <button
                                (click)="toggleFav($event, selectedItem()._id)"
                                        [disabled]="togglingFavId === selectedItem()._id"
                                class="group relative w-10 h-10 flex items-center justify-center rounded-full
                                        transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed
                                        sm:hover:bg-gray-100 sm:hover:scale-110"
                                [ngClass]="isFav(selectedItem()._id) ? 'text-red-500' : 'text-gray-300'"
                            >

                            <!-- Spinner -->
                            <svg *ngIf="togglingFavId === selectedItem._id"
                                class="w-6 h-6 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                            </svg>

                            <!-- Filled -->
                            <svg *ngIf="togglingFavId !== selectedItem._id && _PS.isFav(selectedItem._id)"
                                class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"/>
                            </svg>

                            <!-- Outline -->
                            <svg *ngIf="togglingFavId !== selectedItem._id && !_PS.isFav(selectedItem._id)"
                                class="w-6 h-6 group-hover:text-red-400 transition"
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-width="2"
                                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                            </svg>

                            </button>

                            <!-- CTA -->
                            <button
                            (click)="propertyRequest(selectedItem()._id)"
                                    [disabled]="isLoading"
                            [disabled]="isLoading"
                            class="bg-black text-white
                                    px-5 py-3 sm:px-6 sm:py-3
                                    rounded-xl sm:rounded-full
                                    shadow-lg sm:shadow-none
                                    flex items-center justify-center
                                    min-w-[140px]"
                            >
                            <span *ngIf="!isLoading">Contact Advisor</span>

                            <span *ngIf="isLoading" class="flex items-center gap-2">
                                <svg class="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24"></svg>
                                Processing...
                            </span>
                            </button>

                        </div>

                        <!-- DESKTOP DATE -->
                        <span class="hidden sm:block text-[12px] text-gray-500 ml-4">
                            Last updated: {{ selectedItem().updatedAt | date:'dd MMM yyyy' }}
                        </span>

                    </div>

                    </div>

                    <!-- About -->
                    <div class="my-8">
                        <h3 class="font-semibold text-md mb-1">About the project</h3>
                        <p class="text-sm text-gray-500">{{ selectedItem().description }}</p>
                    </div>

                    <!-- Builder / Meta -->
                    <div class="flex flex-wrap gap-4 pb-8 border-b border-gray-200">
                        <span class="text-sm box-shadow-ff p-2 rounded-sm">
                        Community Category :
                        <b>{{ selectedItem().communityCategory }}</b>
                        </span>

                        <span class="text-sm box-shadow-ff p-2 rounded-sm">
                        Seller Profile :
                        <b>{{ selectedItem().sellerProfile }}</b>
                        </span>

                        <span *ngIf="selectedItem()?.builder" class="text-sm box-shadow-ff p-2 rounded-sm">
                        Builder :
                        <b>{{ selectedItem().builder }}</b>
                        </span>
                    </div>

                    <!-- Price Cards -->
                    <div class="flex flex-wrap gap-3 pb-1 mb-8 border-b border-gray-200 ">
                        <div class="grid grid-cols-1 w-full md:grid-cols-3 gap-4 py-4">

                            @for (item of selectedItem().price; track item._id) {
                                <div class="p-3 flex-1 w-full rounded-xl box-shadow-ff bg-white">

                                    <div class="text-lg font-bold text-indigo-600  mb-2">
                                        <span class="uppercase">{{ item.bhkType }}</span> {{ item.propertyStructureType }}
                                    </div>

                                    <div class="flex gap-4 w-full justify-between items-center">
                                        <div class="flex text-sm flex-col w-full text-gray-600 p-2 bg-gray-50 rounded-sm border-1 border-gray-100">
                                            Area: 
                                            <span class="font-semibold text-gray-900">
                                            {{ item.areaInSq | numberFormat  }} sq.ft
                                            </span>
                                        </div>

                                        <!-- Price -->
                                        <div (click)="togglePrice()" 
                                            class="flex text-sm flex-col w-full text-gray-600 p-2 bg-gray-50 rounded-sm border border-gray-100 cursor-pointer hover:bg-gray-100 transition-colors">
                                            Price:
                                            <span class="font-semibold text-indigo-600 font-bold whitespace-nowrap">
                                            <ng-container  *ngIf="showFullPrice; else shortPrice">
                                                ₹{{ item.price | numberFormat }}
                                            </ng-container>
                                            <ng-template #shortPrice>
                                                {{ item.price | inrShort }}
                                            </ng-template>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            }

                        </div>
                    </div>

                    <!-- Location + Nearby -->
                    <div class="grid sm:grid-cols-2 gap-6 my-8">

                        <div>
                            <!-- Nearby -->
                            <div class="flex flex-col mb-4">
                                <p class="text-[12px] font-semibold text-gray-800 uppercase tracking-wider w-full md:w-auto mb-4">
                                Nearby Places:
                                </p>

                                <div class="flex flex-wrap gap-3">
                                    <div *ngFor="let item of selectedItem().nearbyPlaces"
                                        class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 transition-hover hover:bg-emerald-100">

                                        <span class="h-1 w-1 rounded-full bg-emerald-300"></span>
                                        <span class="text-[11px] font-extrabold text-emerald-900">{{ item }}</span>

                                    </div>
                                </div>
                            </div>

                            <!-- Living Environment -->
                            <div class="flex flex-col">
                                <p class="text-[12px] font-semibold text-gray-800 uppercase tracking-wider w-full md:w-auto mb-4">
                                Living Environment:
                                </p>

                                <div class="flex flex-wrap gap-3">
                                    <div *ngFor="let item of selectedItem().livingEnvironment"
                                        class="flex items-center gap-2 px-3 py-1.5 rounded-sm box-shadow-ff border border-emerald-100 transition-hover hover:bg-emerald-100">
                                    <span class="text-[11px] font-extrabold">{{ item }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Location -->
                        <div>
                            <p class="text-[12px] font-semibold text-gray-400 uppercase mb-3">
                            Location:
                            </p>

                            <p class="text-sm text-gray-700 mb-4 leading-relaxed">
                            {{ formatAddress(selectedItem()) }}
                            </p>

                            <a [href]="selectedItem().location" target="_blank"
                            class="inline-flex items-center gap-2 px-5 py-2 rounded-full border text-gray-700 hover:bg-gray-100 transition">

                            <i class="fas fa-directions"></i>
                            Get Directions

                            </a>
                        </div>

                    </div>

                    <!-- Property Specs -->
                    <div class="bg-[#F5F5F5] rounded-2xl p-6 mb-8">
                        <div class="flex items-center gap-2 mb-6">
                            <p class="text-[14px] mb-8 flex items-center gap-2 text-black font-semibold"> 
                                <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                </svg>
                                Property Specifications
                            </p>
                        </div>

                        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-6 gap-x-4">
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/landarea.svg" alt="" /> Land Area </p>
                                <p class="text-[14px] font-semibold pl-6"> {{ selectedItem().landArea | numberFormat }} sqft. </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/superbuildup.svg" alt="" />Super Built-up Area </p>
                                <p class="text-[14px] font-semibold pl-8"> {{ selectedItem().superBuiltUpArea | numberFormat }} sqft. </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/possession.svg" alt="" /> Possession Status</p>
                                <p class="text-[14px] font-semibold pl-8"> {{ selectedItem().possession}} </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/possession.svg" alt="" /> Possession Year</p>
                                <p class="text-[14px] font-semibold pl-8"> {{ selectedItem().possessionYear }} </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/structure.svg" alt="" /> Structure </p>
                                <p class="text-[14px] font-semibold pl-8"> {{ formatBuildingStr(selectedItem().structure) }} </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/face.svg" alt="" /> Facing </p>
                                <p class="text-[14px] font-semibold pl-8"> {{ selectedItem().facing }} </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/border_inner.svg" alt="" /> Property Type </p>
                                <p class="text-[14px] font-semibold pl-8"> {{ selectedItem().propertyType }}  - <span *ngFor="let item of selectedItem().price"> {{item.propertyStructureType}}</span></p>
                            </div>
                            <!-- <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/bedroom.svg" alt="" /> Property Type </p>
                                <p class="text-[14px] font-semibold pl-6"> {{selectedItem() | json}}</p>
                            </div>  -->
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"><img class="w-5 h-5" src="assets/img/bedroom.svg" alt="" /> Age of Property</p>
                                <p class="text-[14px] font-semibold pl-8">{{ selectedItem().ageOfProperty}}</p>
                            </div>
                            <!-- <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/batthroom.svg" alt="" /> Room Counts </p>
                                <p class="text-[14px] font-semibold pl-6 gap-2" ><span *ngFor="let item of selectedItem().price">{{ item.bhkType }} BHK :  {{ item.areaInSq }} sqft.</span></p>
                            </div> -->
                            <!-- <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/batthroom.svg" alt="" /> Total Area </p>
                                <p class="text-[14px] font-semibold pl-6"> {{ selectedItem().totalArea }} </p>
                            </div> -->
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/furniture.svg" alt="" /> Furnishing </p>
                                <p class="text-[14px] font-semibold pl-8"> {{ selectedItem().furnishing }} </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/price.svg" alt="" /> Avg. price </p>
                                <p class="text-[14px] font-semibold pl-8" *ngIf="selectedItem()?.price?.length">₹ {{ selectedItem().price[0].averagePrice | numberFormat }}/sqft </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/rera.svg" alt="" /> Rera </p>
                                <p class="text-[14px] font-semibold pl-8 underline break-words max-w-[150px] sm:max-w-[200px] w-54"> {{ selectedItem().reraNumber }} </p>
                            </div>
                            <div>
                                <p class="text-[14px] flex gap-2 text-black font-normal mb-1"> <img class="w-5 h-5" src="assets/img/parking.svg" alt="" /> Parking Availability</p>
                                <p class="text-[14px] font-semibold pl-8" > {{ selectedItem().parking}} {{ selectedItem().parkingCapacity }} </p>
                            </div>
                        </div>

                        <!-- Additional Rooms -->

                        <div class="mt-8 pt-6 border-t border-gray-200">
                            <p class="text-[14px] flex items-center gap-2 text-black font-semibold mb-4"> 
                                <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                                Additional Rooms 
                            </p>
                            
                            <div class="flex flex-wrap gap-3 pl-2">
                                @for (room of selectedItem().additionalRooms; track room) {
                                <div class="flex items-center gap-3 px-4 py-2 hover:border-indigo-400 hover:bg-indigo-50/30 transition-all duration-300 group cursor-default">
                                    <div class="w-6 h-6 rounded text-black flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                                        <i [class]="getRoomIcon(room)" class="text-[10px]"></i>
                                    </div>
                                    <span class="text-[13px] font-semibold text-gray-700 group-hover:text-indigo-900">
                                        {{ room }}
                                    </span>
                                </div>
                                }
                            </div>
                            
                        </div>

                        <!-- Amenities -->

                        <div class="mt-8 pt-6 border-t border-gray-200">
                            <p class="text-[14px] flex items-center gap-2 text-black font-semibold mb-4"> 
                                <svg class="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                </svg>
                                Amenities 
                            </p>
                            
                            <div class="flex flex-wrap gap-3 pl-2">
                                @for (amenity of getVisibleAmenities(selectedItem().amenities); track amenity.key) {

                                    <div class="flex items-center gap-3 px-4 py-2 hover:border-indigo-400 hover:bg-indigo-50/30 transition-all duration-300 group cursor-default">
                                        <div class="w-6 h-6 rounded text-black flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path [attr.d]="amenity.icon" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <span class="text-xs font-semibold text-gray-700 group-hover:text-indigo-700">
                                            {{ amenity.label }}
                                        </span>
                                    </div>
                
                                } @empty {
                                    <p class="text-sm text-gray-400 italic">No amenities available for this property.</p>
                                }
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </main>
    </div>
</div>
<!-- Success Modal -->
<div *ngIf="showSuccessModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" (click)="closeSuccessModal()"></div>
    <!-- Modal Card -->
    <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-6 animate-scale-in">
        <!-- Icon -->
        <div class="flex justify-center mb-4">
            <div class="w-12 h-12 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-xl font-bold"> ✓ </div>
        </div>
        <!-- Message -->
        <p class="text-center text-gray-800 font-medium leading-relaxed"> Thank you for your interest. An advisor will contact you soon on your registered mobile number. </p>
        <!-- Action -->
        <div class="mt-6 flex justify-center">
            <button (click)="closeSuccessModal()" class="px-6 py-2.5 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 transition"> Okay </button>
        </div>
    </div>
</div>